// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../index.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const QuestionnaireStepFinalDocument = `
    query questionnaireStepFinal($id: ID!) {
  questionnaire(id: $id) {
    redirectLink {
      ...linkItem
    }
  }
}
    ${LinkItemFragmentDoc}
${PageLinkFragmentDoc}
${PostLinkFragmentDoc}
${CustomLinkFragmentDoc}
${LinkQuestionnaireFragmentDoc}
${LinkItemOpenEnquiryFormFragmentDoc}
${LinkItemErRecommendationsFragmentDoc}`;

export function useQuestionnaireStepFinalQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.QuestionnaireStepFinalQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.QuestionnaireStepFinalQuery, SchemaTypes.QuestionnaireStepFinalQueryVariables | undefined>({ query: QuestionnaireStepFinalDocument, variables: undefined, ...options });
};